import { Me } from "../types/data";

export default {
    name: "Edvin Ljungqvist",
    age: 20,
    experience: 6,
    socials: {
        github: "edvinljungqvist",
        instagram: "edvin.ljungqvist",
        linkedin: "edvin-ljungqvist-02603630b",
        discord: "ljungandev"
    },
    mail: "edvin.ljungan@gmail.com"
} as Me;
